<template>
  <button
    class="hamburger"
    :class="{'hamburger--active': menuOpen }"
    type="button"
    @click="toggleMenu(!menuOpen)"
  >
    <span class="hamburger__inner" />
  </button>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    components: {

    },
    props: {},
    methods: {
      toggleMenu (status) {
        this.$store.commit('changeMenu', status, { module: 'menu' })
      }
    },
    computed: {
      ...mapState({
          menuOpen: state => state.menu.menuOpen
        }
      )
    }
  };
</script>
<style lang="scss">
  @import "../../styles/shared/shared";
  $hamburger-width: 22px;
  $hamburger-line-height: 2px;
  $hamburger-line-spacer: 6px;
  .hamburger {
    $this: &;
    position: relative;
    width: $hamburger-width;
    height: ($hamburger-line-height) + ($hamburger-line-spacer * 2);
    padding: 0;
    border: 0;
    margin: 0;
    display: inline-block;
    cursor: pointer;
    transition: opacity 0.15s ease;
    text-transform: none;
    background-color: transparent;
    overflow: visible;
    &:focus,
    &:hover {
      opacity: 0.7;
      outline: none;
    }
    &__inner {
      position: absolute;
      top: ($hamburger-line-height / 2);
      margin-top: -($hamburger-line-height / 2);
      transition-timing-function: cubic-bezier(.68,-.55,.265,1.55);
      transition-duration: .275s;
      &,
      &:before,
      &:after {
        position: absolute;
        width: $hamburger-width;
        height: $hamburger-line-height;
        display: block;
        background-color: $white;
        border-radius: $hamburger-line-height;
        transition-property: transform;
      }
      &:before,
      &:after {
        content: "";
      }
      &:before {
        top: $hamburger-line-spacer;
        transition: opacity .125s ease .275s;
      }
      &:after {
        top: ($hamburger-line-spacer * 2);
        transition: transform .275s cubic-bezier(.68,-.55,.265,1.55);
      }
    }
    &--active {
      #{$this}__inner {
        transition-delay: 75ms;
        transform: translate3d(0,$hamburger-line-spacer,0) rotate(135deg);
        &:before {
          transition-delay: 0s;
          opacity: 0;
        }
        &:after {
          transition-delay: 75ms;
          transform: translate3d(0,-($hamburger-line-spacer * 2),0) rotate(-270deg);
        }
      }
      &:hover {
        opacity: 0.7;
      }
    }
  }
</style>
